import * as Types from '@mildang/graphql-artifact';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendAuthVerifySmsMutationVariables = Types.Exact<{
  input: Types.SendAuthVerifySmsInput;
}>;


export type SendAuthVerifySmsMutation = { __typename?: 'Mutation', sendAuthVerifySMS: { __typename?: 'SendAuthVerifySMSPayload', result: boolean } };


export const SendAuthVerifySmsDocument = gql`
    mutation SendAuthVerifySMS($input: SendAuthVerifySMSInput!) {
  sendAuthVerifySMS(input: $input) {
    result
  }
}
    `;
export type SendAuthVerifySmsMutationFn = Apollo.MutationFunction<SendAuthVerifySmsMutation, SendAuthVerifySmsMutationVariables>;

/**
 * __useSendAuthVerifySmsMutation__
 *
 * To run a mutation, you first call `useSendAuthVerifySmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuthVerifySmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuthVerifySmsMutation, { data, loading, error }] = useSendAuthVerifySmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAuthVerifySmsMutation(baseOptions?: Apollo.MutationHookOptions<SendAuthVerifySmsMutation, SendAuthVerifySmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAuthVerifySmsMutation, SendAuthVerifySmsMutationVariables>(SendAuthVerifySmsDocument, options);
      }
export type SendAuthVerifySmsMutationHookResult = ReturnType<typeof useSendAuthVerifySmsMutation>;
export type SendAuthVerifySmsMutationResult = Apollo.MutationResult<SendAuthVerifySmsMutation>;
export type SendAuthVerifySmsMutationOptions = Apollo.BaseMutationOptions<SendAuthVerifySmsMutation, SendAuthVerifySmsMutationVariables>;
export const namedOperations = {
  Mutation: {
    SendAuthVerifySMS: 'SendAuthVerifySMS'
  }
}